import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "admin" */ '@/layouts/PrincipalLayout.vue'),
    children: [
        {
            path: '',
            name: 'dashboard-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        transKey: 'breadcrumbs.dashboard-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "dashboard-index" */ '@/modules/admin/dashboard/views/Index.vue')
        }
    ]
}